'use client'

import { FavoriteButtonSmall } from 'favorite/src/FavoriteButtonSmall'
import { dataTestIds } from 'product-card/constants/dataTestIds'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useSelectedColor } from 'product-card/hooks/useSelectedColor/useSelectedColor'

import { useMemo } from 'react'
import styles from './FavoriteButton.module.scss'

export const FavoriteButton = () => {
	const { dataTestId, location, productId } = useProductCard()
	const { selectedColor } = useSelectedColor()

	const currentDataTestIds = useMemo(
		() => ({
			active: dataTestIds.productCardFavoriteActive(dataTestId),
			inactive: dataTestIds.productCardFavoriteInactive(dataTestId),
		}),
		[dataTestId]
	)

	if (!selectedColor) {
		return null
	}

	return (
		<FavoriteButtonSmall
			className={styles.favoriteButton}
			productId={productId}
			selectedColorId={selectedColor.id}
			dataTestIds={currentDataTestIds}
			location={location}
			notification
		/>
	)
}
